import './styles/base.css';
import { createRouter } from "./pages/index.jsx";
import { RouterProvider } from "react-router-dom";
import React from 'react';
import { useConfig } from './context/ConfigContext.js';

function App({ logo }) {
  const router = createRouter(logo);
  const { storeSettings } = useConfig();

  return (
    <>
      {/* Ejemplo: mostrar el tipo de logo actual */}
      <div style={{ position: 'absolute', top: 0, right: 0, fontSize: 12, color: '#888' }}>
        Logo type: {storeSettings.logoType}
      </div>
    <RouterProvider router={router} />
    </>
  );
}

export default App; 